export function useCodeBoxTyping(shared) {
  const {codeBoxContent, setBoxesFromCode, focusInput, focusNextInput, focusPrevInput} = shared;

  function getCleanDigit(value) {
    return String(value || "").replace(/[^0-9]/g, "");
  }

  // a whole code at once (iOS one-time-code autofill, or a paste the paste handler missed)
  function fillWholeCode(clean) {
    setBoxesFromCode(clean);
    focusInput(5);
  }

  function onDigitInput(event, index) {
    const digit = codeBoxContent.value[index];
    const clean = getCleanDigit(digit);
    if (clean.length >= 6) return fillWholeCode(clean);
    const typed = clean.slice(-1); // a box typed over: the new digit
    if (typed !== digit) codeBoxContent.value[index] = typed;
    if (typed && index < codeBoxContent.value.length - 1) focusNextInput(index);
  }

  function moveLeft(event, index) {
    focusPrevInput(index);
    event.preventDefault();
  }

  function moveRight(event, index) {
    focusNextInput(index);
    event.preventDefault();
  }

  function handleDeleteKey(event, index) {
    const current = codeBoxContent.value[index];
    if (current) {
      codeBoxContent.value[index] = "";
      event.preventDefault();
      return;
    }
    if (index <= 0) {
      event.preventDefault();
      return;
    }
    codeBoxContent.value[index - 1] = "";
    focusPrevInput(index);
    event.preventDefault();
  }

  function onDigitKeydown(event, index) {
    const key = event.key;
    if (key === "ArrowLeft") return moveLeft(event, index);
    if (key === "ArrowRight") return moveRight(event, index);
    if (key === "ArrowUp") { focusInput(0); event.preventDefault(); return; }
    if (key === "ArrowDown") { focusInput(5); event.preventDefault(); return; }
    if (key === "Backspace" || key === "Delete") handleDeleteKey(event, index);
  }

  return {onDigitInput, onDigitKeydown};
}
